import React, { memo, PropsWithChildren, FC } from "react";
import useGuestPageContainer from "./index.hooks";
import cn from "classnames";

type GuestPageContainerProps = {
  className?: string;
};

const GuestPageContainer: FC<PropsWithChildren<GuestPageContainerProps>> = ({
  children,
  className,
}) => {
  const { styles } = useGuestPageContainer();

  return <div className={cn(className, styles.container)}>{children}</div>;
};

export default memo(GuestPageContainer);
